export default 'marketingSettingsPage';
